import React, { useState, useEffect } from 'react';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch('/api/auth/me', { credentials: 'include' });
        if (res.ok) {
          // Se o servidor responder 200, o usuário já está logado
          window.location.href = '/home';
        }
      } catch (err) {
        console.error('Erro ao verificar sessão:', err);
      }
    };
    checkSession();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const body = { username, password };
      if (token) {
        body.twoFactorToken = token;
      }

      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'include', // Inclui cookies
      });

      if (!response.ok) {
        const errorData = await response.json();
        setMessage('Erro: ' + (errorData.message || 'Algo deu errado.'));
        return;
      }

      const data = await response.json();

      if (data.nextStep === 'home') {
        window.location.href = '/home'; // Redireciona para a página inicial
      } else if (data.nextStep === '2fa') {
        if (data.message) {
          setMessage(data.message);
        } else {
          setMessage(data.method === 'app'
            ? 'Por favor, insira o código do seu aplicativo autenticador acima.'
            : 'Código enviado para seu email. Digite-o acima.');
        }
      }
    } catch (error) {
      console.error('Erro ao realizar login:', error);
      setMessage('Erro de conexão. Tente novamente mais tarde.');
    }
  };

  return (
    <div style={styles.container}>
      <img src="/logo-ra.png" alt="RA MultiServices Logo" style={styles.logo} />
      <h1>Login</h1>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Usuário:</label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.input}
          required
        />

        <label style={styles.label}>Senha:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />

        <label style={styles.label}>Token 2FA (se necessário):</label>
        <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          style={styles.input}
        />

        <button type="submit" style={styles.button}>
          Entrar
        </button>
      </form>
      {message && <p style={styles.message}>{message}</p>}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '30px',
  },
  logo: {
    width: '180px',
    height: 'auto',
    marginBottom: '20px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
  },
  label: {
    marginBottom: '5px',
    fontSize: '14px',
  },
  input: {
    marginBottom: '15px',
    padding: '10px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  button: {
    padding: '10px',
    fontSize: '14px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  buttonHover: {
    backgroundColor: '#0056b3',
  },
  message: {
    marginTop: '20px',
    fontSize: '14px',
    color: 'red',
  },
};

export default Login;
